import React from "react"
// import './EmailMarketing.css'
import { Link } from "react-router-dom"


import emailMarketingBanner from '../../assets/bannerImages/emailMarketing.jpg'

import personalizedEmails from '../../assets/images/personalizedEmails.jpg'
import automatedEfficiency from '../../assets/images/automatedEfficiency.jpg'
import dataDrivenOptimization from '../../assets/images/dataDrivenOptimization.jpg'

import audienceSegmentation from '../../assets/images/audienceSegmentation.jpg'
import compellingContentCreation from '../../assets/images/compellingContentCreation.jpg'
import performanceTrackingAndOptimization from '../../assets/images/continuousMonitoringAndImprovement.jpg'



export default function EmailMarketing(){
    return(
        <div className="emailMarketing">
            <EMR1/>
            <EMR2/>
            <EMR3/>
            <EMR4/>
            <ContactSection/>
            {/* this contact section's css is in social media marketing page's css file */}
        </div>
    )
}

function EMR1(){
    return(
        <div className='emr1'>
            <img loading="lazy" src={emailMarketingBanner} alt='em-banner' className='em-banner-img'/>
            <h1 className='emr1-head'>Email Marketing</h1>
            <div className='overlay'></div>
        </div>
    )
}

function EMR2(){
    return(
        <div className='emr2'>
            <div className='strip'>
                <h1>What is <span>Email Marketing</span>?</h1>
                <hr/>   
                <p>Email Marketing is a digital strategy focused on sending targeted emails to specific audiences, aiming to promote products, services, or content, and foster customer relationships. Through personalized communication and automation, it helps businesses engage with their audience effectively, increase brand awareness, and drive conversions.</p>
            </div>
        </div>
    )
}

function EMR3(){
    return(
        <div className='emr3'>
            <div className='rowThreeContainer'>
                <h1 className='rowThreeHead'>
                Why <span>Choose Bixian</span> for Email Marketing?
                </h1>
                <p className='rowThreeContext'>
                Bixian excels in Email Marketing, offering tailored campaigns designed to captivate audiences and drive action. With our strategic approach and commitment to delivering measurable results, we ensure your email marketing efforts yield maximum impact and engagement.
                </p>
                <div className='rowThreeBoxes'>
                    {/* box 1 */}
                    <div className='box boxOne'>
                        <div className='context'>
                            <img loading="lazy" src={personalizedEmails} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Personalized Emails
                            </h2>
                            <p className='boxPara'>
                            We craft email campaigns that resonate with your audience, boosting open rates, clicks, and conversions.
                            </p>
                        </div>
                    </div>
                    {/* box 2 */}
                    <div className='box boxTwo'>
                        <div className='context'>
                            <img loading="lazy" src={automatedEfficiency} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Automated Efficiency
                            </h2>
                            <p className='boxPara'>
                            We streamline email marketing with advanced tools for maximum results. From drips to follow-ups, we ensure timely communication.
                            </p>
                        </div>
                    </div>
                    {/* box 3 */}
                    <div className='box boxThree'>
                        <div className='context'>
                            <img loading="lazy" src={dataDrivenOptimization} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Data-Driven Optimization
                            </h2>
                            <p className='boxPara'>
                            Track performance with detailed analytics to optimize campaigns and maximize ROI. We continuously improve for success.
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

function EMR4(){
    return(
        <div className='emr4'>
            <div className='rowFourContainer'>
                <div className='rowFourContext'>
                    <h1 className='rowFourHead'>Our Process</h1>
                    <p className='rowFourPara'>
                    Transform your email campaigns into powerful marketing tools with Bixian's Email Marketing strategies. Reach your target audience effectively, drive engagement, and nurture leads with personalized email campaigns tailored to your business goals.
                    </p>
                </div>
                <div className='rowFourBoxes'>
                    <div className='box boxOne'>
                            <img loading="lazy" src={audienceSegmentation} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Audience Segmentation</h2>
                        <p className='boxPara'>We segment your email list based on demographics, behaviors, and interests, allowing for highly targeted and personalized email campaigns that resonate with your audience.</p>
                    </div>
                    <div className='box boxTwo'>
                            <img loading="lazy" src={compellingContentCreation} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Compelling Content Creation</h2>
                        <p className='boxPara'>Our team crafts engaging and relevant email content, including captivating subject lines, persuasive copy, and compelling visuals, to drive opens, clicks, and conversions.</p>
                    </div>
                    <div className='box boxThree'>
                            <img loading="lazy" src={performanceTrackingAndOptimization} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Performance Tracking and Optimization</h2>
                        <p className='boxPara'>With robust analytics and tracking tools, we monitor the performance of your email campaigns in real-time, identifying areas for improvement and implementing optimization strategies to maximize results.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

function ContactSection(){
    return(
        <div className="contactSection">
                <div className="box">
                    <div className="context">
                        <h1>Wanna Discuss More About Our Email Marketing?</h1>
                        <p>Schedule a free consultation and esitmate with our expert.</p>
                    </div>
                    <div className="buttonHolder">
                        <Link to='/contact'><button>Get A Free Estimation</button></Link>
                    </div>
                </div>
            </div>
    )
}